import {Quiz} from "../../Shared/Model/QuizData";
import {Settings} from "../../Shared/Model/GameData";
import {ScoreData} from "../../Shared/Components/Score";
import {QuizPlayMemo} from "./QuizPlayMemo";
import {QuizPlayQuestions} from "./QuizPlayQuestions";

export interface QuizPlayProps {
    quiz: Quiz
    settings: Settings
    onFinish: (score: ScoreData) => void
    onCancel: () => void
}

export default function QuizPlay(props: QuizPlayProps) {
    switch (props.quiz.type) {
        case "memo":
            return <QuizPlayMemo {...props} />
        case "quiz":
            return <QuizPlayQuestions {...props} />
        default:
            return null;
    }
}

